export default __webpack_public_path__ + "static/media/icon_mouse_scroll.626eae89.svg";